// extracted by mini-css-extract-plugin
export default {"logoCircle":"desktop_logoCircle__15Z81","logoIcon":"desktop_logoIcon__pB-nS","titleCall":"desktop_titleCall__O7L4F"};